import { Shield, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
const GuaranteeSection = () => {
  const guarantees = ["Teste grátis e só pague se gostar", "Sem contrato. Sem burocracia", "Sem compromisso", "Cancele quando quiser"];
  return <section className="py-12 md:py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-card rounded-xl md:rounded-2xl shadow-lg p-6 md:p-12 text-center">
            {/* Icon */}
            <div className="mb-4 md:mb-6 flex justify-center">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full flex items-center justify-center">
                <Shield className="w-8 h-8 md:w-10 md:h-10 text-primary" />
              </div>
            </div>

            {/* Title */}
            <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4 md:mb-6">
              🔐 Comece agora sem risco
            </h2>

            {/* Guarantees List */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 max-w-2xl mx-auto mb-6 md:mb-8">
              {guarantees.map((guarantee, index) => <div key={index} className="flex items-center gap-2 md:gap-3 text-left bg-muted/50 p-3 md:p-4 rounded-lg">
                  <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-success flex-shrink-0" />
                  <span className="text-sm md:text-base text-foreground font-medium">{guarantee}</span>
                </div>)}
            </div>

            {/* Badge */}
            <div className="inline-block bg-success/10 border-2 border-success text-success px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-bold mb-6">✓ 10 dias de garantia</div>

            {/* CTA */}
            <div className="mt-6 md:mt-8">
              <Button variant="cta" size="lg" className="w-full md:w-auto text-base md:text-lg px-6 md:px-8 py-4 md:py-6 h-auto" asChild>
                <Link to="/auth">
                  Começar Agora Sem Risco
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default GuaranteeSection;